import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsGelaender,
        updatePfostenFormGelaender
        } from '../../../../store/actions/gelaender';
import {Textfield} from '../../../../module/textField';


const Step_5 = (props) => {

    const [pfosten_form, updatePfosten_Form] = useState('');

    useEffect(() => {
        updateItems();
    })

   const updateItems = () => {
        const {pfosten_form} = props.data[props.modell_type];

        //update pfosten form
        updatePfosten_Form(pfosten_form);

        //update steps
        if (props.modell_type === 2) props.updateSteps(5);
        if (props.modell_type === 3) props.updateSteps(3);
        else props.updateSteps(4);

        if(pfosten_form || props.data[props.modell_type].allVisitedSteps) {
            //update steps
            if (props.modell_type === 2) props.updateSteps(6);
            if (props.modell_type === 3) props.updateSteps(4);
            else props.updateSteps(5);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const updatePfostenForm = ev => {
        let pfosten_form = ev.target.value;
        props.updatePfostenForm(pfosten_form);
        updateItems();
   }

   let pfosten_form_options = [
       {titel: 'Rundrohr 42,4 mm'},
       {titel: 'Rundrohr 60 mm'},
       {titel: 'Rechteck 50 x 30 mm'},
       {titel: 'Quadraht 40 x 40 mm'},
       {titel: 'Quadraht 60 x 60 mm'}

   ];

    return (
        <div className="step_wrapper">
              <div className="step_icon_wrapper">
              <h2 className="step_header">Form der Pfosten</h2>
                <div className="inner_textfield_wrapper">
                    <Textfield
                         label="Bitte wählen"
                         type="text"
                         select
                         rowsMax={1}
                         value={pfosten_form}
                         onChange={updatePfostenForm}
                         array_options={pfosten_form_options}
                         name='Pfosten'
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updatePfostenForm: ev => dispatch(updatePfostenFormGelaender(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_5);
